import PropTypes from 'prop-types';

export const Props = {
  history: PropTypes.shape({}),
};

export const DefaultProps = {
  history: {},
};
